'use client'

/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-extraneous-dependencies */

import {
    styled,
    Flex,
    $fontWeightNormal,
    $fontSize,
    $fontWeightLight
  } from '@acko-tech/building-blocks.ui.common'

export const TableTopContainer = styled(Flex)`
  flex-direction: column;
  box-sizing: border-box;
  max-width: 1068px;
  margin-left: auto;
  margin-right: auto;
  scroll-margin-top: 80px;

  @media screen and (max-width: 1141px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  @media screen and (max-width: 425px) {
    padding: 20px 20px;
  }
`

export const TableContainer = styled(Flex)`
  justify-content: center;

  @media screen and (max-width: 768px) {
    justify-content: flex-start;
    overflow-x: auto;
    scroll-behavior: smooth;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const TableHyperlink = styled.a`
  font-weight: ${$fontWeightLight};
  font-size: inherit;
  color: #1b73e8;
  vertical-align: baseline;

  &:hover {
    text-decoration: underline;
  }
`

  export const StyledTable = styled.table`
    font-size: ${$fontSize.xxxs};
    width: 100%;
    text-align: center;
    border-collapse: collapse;
    margin-bottom: 15px;
    margin-top: 15px;

    text-align: ${(props) => (props.alignment ? props.alignment : 'unset')};

    & th {
        text-align: ${(props) => (props.alignment ? props.alignment : 'unset')};
    }

    @media all and (max-width: 330px) {
        width: 100vw;
        margin-left: -20px;
    }
  `

  export const TD = styled.td`
    padding: 10px;
    border: 1px solid #8990a1;
    font-weight: ${$fontWeightNormal};
    font-size: ${$fontSize.xxs};
    color: #555a68;

    & > a {
        color: #288ce4;
        text-decoration: underline;
        vertical-align: baseline;
    }
  `
  export const TH = styled.th`
    font-weight: bold;
    font-size: ${$fontSize.xs};
    /* text-align: center; */
    border: 1px solid #8990a1;
    padding: 10px;
    background: rgb(248, 247, 252);

    @media all and (max-width: 480px) {
      font-size: ${$fontSize.xxs};
    }
  `
